import { useSelector } from "react-redux";
import { login_ } from "../reducers/login";

export const useAuthenticated = () => {
    const loginDetails = useSelector(login_);
    return loginDetails.UserID !== "";
};

